<template>
<div>
  <component
    :is="matchItemComp"
    v-if="matchId && matchType"
    :matchTypeProp="matchType"
    :liveTrackerForceEnabled="true"
  />
  <empty-state v-if="!matchId && !matchType" :message="t(emptyStateMessage)" :icon-class="emptyStateIcon" />
</div>
</template>

<script>
  import MatchDetailsWidget from '../match-details/widget-match-details';
  import MatchDetailsWidgetUs from '../match-details/widget-match-details-us';
  import { EventBus } from '../../../services/event-bus-service';
  import { EmptyState, ICON_CLASS } from '../../shared/empty-state';
  import { LAYOUT_NAME } from '../../../models/enums/layout-const';
  import { urlFriendlyParam } from '@bto-services/utils';

  export default {
    name: 'EventViewWidget',
    components: {
      MatchDetailsWidget,
      EmptyState,
      MatchDetailsWidgetUs
    },
    data() {
      return {
        matchId: this.$router.currentRoute.params.matchId || null,
        matchType: null,
        emptyStateIcon: ICON_CLASS.LIVE,
        emptyStateMessage: 'Public.NoLiveMatches',
        isUS: APP_SETTINGS.settings.layout === LAYOUT_NAME.US,
      };
    },
    computed: {
      matchItemComp() {
        if (this.isUS) {
          return MatchDetailsWidgetUs;
        }
        return MatchDetailsWidget;
      },
    },
    created() {
      EventBus.$on('liveFixtureMatchClicked', this.handleFixtureClick);
      EventBus.$on('upcomingFixtureMatchClicked', this.handleFixtureClick);
      this.matchType = this.$router.currentRoute.name === 'seoGameLive' ? 'live' : 'prematch';
    },
    beforeDestroy() {
      EventBus.$off('liveFixtureMatchClicked', this.handleFixtureClick);
      EventBus.$off('upcomingFixtureMatchClicked', this.handleFixtureClick);
    },
    watch: {
      '$route': function (to) {
        // hide match-detial-widget if route has no matchId param
        if (!to.params.matchId) {
          this.matchId = null;
        }
      }
    },
    methods: {
      handleFixtureClick(match) {
        let matchId, matchType;

        if (match.isLiveMatch) {
          matchId = match.betRadarId;
          const categoryName = urlFriendlyParam(match.tournamentName);
          const eventName = `${urlFriendlyParam(match.homeTeam)}-vs-${urlFriendlyParam(match.guestTeam)}`;
          const sportName = urlFriendlyParam(match.sportName);
          matchType = 'live';
          this.$router.push({
            name: 'seoGameLive',
            params: {
              sportName,
              categoryName,
              eventName,
              matchId: matchId,
            },
          });
        } else {
          matchId = match.matchId;
          matchType = 'prematch';
          this.$router.push({
            name: 'matchDetailsLive',
            params: {
              matchType,
              matchId: matchId,
            },
          });
        }
        this.matchType = matchType;
        this.matchId = matchId;
      },
    },
  };
</script>
